import { render } from "./ClaimNote.vue?vue&type=template&id=94b94732&scoped=true&bindings={}"
import script from "./ClaimNote.vue?vue&type=script&lang=ts"
export * from "./ClaimNote.vue?vue&type=script&lang=ts"

import "./ClaimNote.vue?vue&type=style&index=0&id=94b94732&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-94b94732"

export default script